import React from 'react';
import styled, { keyframes } from 'styled-components';
import loadingGif from '/loading.webp'; 

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #fff;
  animation: ${fadeIn} 1s ease-in-out;
`;

const Message = styled.h1`
  font-size: 2rem;
  color: #343a40;
  margin-bottom: 20px;
`;

const LongMessage = styled.p`
    font-size: 1.4rem;
    color: #111;
`;

const Gif = styled.img`
  width: 500px;
  height: auto;
  border: 0;
`;

const WorkingOnIt = () => (
  <Container>
    <Message>Thank you for visiting my portfolio. I'm currently updating it!</Message>
    <LongMessage>But in the meantime, you can explore my latest projects on my <b><a href='https://github.com/ksachin7' target='_blank'>GitHub</a></b></LongMessage>
    <Gif src={loadingGif} alt="Loading..." />
  </Container>
);
export default WorkingOnIt;